import { Component } from '@angular/core';
import { AddCall } from 'src/providers/addvCall';
import { ServicesProvider } from 'src/providers/services';
import { CommonService } from 'src/providers/common';
@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss']
})
export class TabsPage {
  tabs: any;
  selectedTab: any;
  chating: any;
  totalNotificationsCount: any;
  totalNotificationsCountOne: any;
  totalNotificationsCountTwo: any;
  totalNotificationsCountThree: any;
  totalNotificationsCountFour: any;
  totalNotificationsCountFive: any;
  totalNotificationsCountSix: any;
  totalNotificationsCountSeven: any;
  totalNotificationsCountEight: any;
  totalNotificationsCountNine: any;
  totalNotificationsCountTen: any;
  totalNotificationsCountEleven: any;


  constructor(
    public addCall: AddCall,
    private services: ServicesProvider,
    public common: CommonService
  ) { }

  ngOnInit() {
    // this.Notificationcount();

  }
  goShopping() {
    localStorage.setItem("NopayGoBack", "newEnter");
  }

  ionViewWillEnter() {
    this.selectedTab = 'home';
    this.common.setDoctorDetails(false);
    console.log(this.common.commonNotification,"Notifications");

  }
  // openChat() {
  //   this.router.navigate(['/tabs/chat']);
  // }


  // setCurrentTab() {
  //   this.selectedTab = this.tabs.getSelected();
  // }


  chatPage(event: any) {
    // 
    this.chating = event.tab;
    this.selectedTab = event.tab;
  }

  Notificationcount() {
    let apidate = JSON.stringify({
      "memberId": localStorage.getItem("patient_id"),
      "notificationDate": new Date().toISOString().split("T")[0],
      "app_language": localStorage.getItem("selectedLanguage")
    })

    this.services.postRequest("getMemberNotificationsCount", apidate).subscribe(res => {
      console.log(res.data);
      let getnoti = [];
      let intcount = 0;
      getnoti.push(res.data)
      //  console.log(this.NotificationCount);
      for (const key in getnoti) {
        console.log(key);
        for (let nestedKey in getnoti[key]) {
          console.log(getnoti[key][nestedKey].count, "nestkey");
          intcount += getnoti[key][nestedKey].count
        }
      }
      this.totalNotificationsCount = intcount;
      localStorage.setItem("Nofycount", this.totalNotificationsCount)
      console.log(intcount);
      // if (res.data.doctor_module.count != 0 && res.data.doctor_module.count != null) {
      //   this.totalNotificationsCountOne = res.data.doctor_module.count
      // } else if (res.data.lab_module.count != 0 && res.data.lab_module.count != null) {
      //   this.totalNotificationsCountTwo = res.data.lab_module.count
      // } else if (res.data.clinic_module.count != 0 && res.data.clinic_module.count != null) {
      //   this.totalNotificationsCountThree = res.data.clinic_module.count
      // } else if (res.data.nurse_module.count != 0 && res.data.nurse_module.count != null) {
      //   this.totalNotificationsCountFour = res.data.nurse_module.count
      // } else if (res.data.trainer_module.count != 0 && res.data.trainer_module.count != null) {
      //   this.totalNotificationsCountFive = res.data.trainer_module.count
      // } else if (res.data.tc_module.count != 0 && res.data.tc_module.count != null) {
      //   this.totalNotificationsCountSix = res.data.tc_module.count
      // } else if (res.data.diet_module.count != 0 && res.data.diet_module.count != null) {
      //   this.totalNotificationsCountSeven = res.data.diet_module.count
      // } else if (res.data.pharmacy_module.count != 0 && res.data.pharmacy_module.count != null) {
      //   this.totalNotificationsCountEight = res.data.pharmacy_module.count
      // } else if (res.data.room_module.count != 0 && res.data.room_module.count != null) {
      //   this.totalNotificationsCountNine = res.data.room_module.count
      // } else if (res.data.shopping_module.count != 0 && res.data.shopping_module.count != null) {
      //   this.totalNotificationsCountTen = res.data.shopping_module.count
      // } else if (res.data.physio_module.count != 0 && res.data.physio_module.count != null) {
      //   this.totalNotificationsCountEleven = res.data.physio_module.count
      // }
      // 
      // this.totalNotificationsCount = this.totalNotificationsCountOne + this.totalNotificationsCountTwo + this.totalNotificationsCountThree + this.totalNotificationsCountFour + this.totalNotificationsCountFive + this.totalNotificationsCountSix + this.totalNotificationsCountSeven + this.totalNotificationsCountEight + this.totalNotificationsCountNine + this.totalNotificationsCountTen + this.totalNotificationsCountEleven;
      // console.log(this.totalNotificationsCount, "totalNotificationsCount");

    })
    // this.playAudio();  
    // this.onAudioPlay();
    // this.playSound();
  }

}